import {
  HelpLinesComponentShape,
  HelpLinesComponentVisible,
  ShapeTypeEnum
} from '@inter-ikea-storageone/range';
import { useCore } from 'contexts/core';
import { resetEntities } from 'ducks/core';
import { setShape } from 'ducks/helpLines';
import { useAppDispatch } from 'ducks/hooks';
import { useCallback } from 'react';

const useRestartPlanner = () => {
  const dispatch = useAppDispatch();
  const coreApi = useCore();
  const scene = coreApi.entities.getScene();

  const restart = useCallback(() => {
    coreApi.resetScene();
    dispatch(resetEntities({ productEntities: [], shoppingBagEntities: [] }));
    dispatch(setShape(ShapeTypeEnum.off));
    scene?.addComponent(new HelpLinesComponentShape(ShapeTypeEnum.off, []));
    scene?.addComponent(new HelpLinesComponentVisible(false));
  }, [coreApi, dispatch, scene]);

  return restart;
};

export default useRestartPlanner;
